if (!customElements.get('novyra-market-prices')) {
  customElements.define('novyra-market-prices', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('script').textContent);
      this.host = this.closest('.nvp');
      if (!this.host) return;
      this.button = this.host.querySelector('[data-demo]');
      this.quantityInput = this.host.querySelector('.nvp-quantity input');
      this.form = this.host.querySelector('[data-novyra-form]');
      this.format = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency, currencyDisplay: 'code' });
      this.host.addEventListener('change', () => this.refresh());
      this.host.addEventListener('input', event => {
        if (event.target === this.quantityInput) this.refresh();
      });
      this.form.addEventListener('submit', event => this.add(event));
      queueMicrotask(() => {
        const requested = new URL(location.href).searchParams.get('variant');
        const selected = this.config.variants.find(v => String(v.id) === requested);
        if (selected) {
          const colour = [...this.host.querySelectorAll('.nvp-colour input')].find(input => input.value === selected.colour);
          const size = [...this.host.querySelectorAll('.nvp-sizes input')].find(input => input.value === selected.size);
          if (colour && size) {
            colour.checked = size.checked = true;
            colour.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        this.refresh();
      });
    }
    selection() {
      const colour = this.host.querySelector('.nvp-colour input:checked')?.value;
      const size = this.host.querySelector('.nvp-sizes input:checked')?.value;
      return this.config.variants.find(v => v.colour === colour && v.size === size);
    }
    refresh() {
      if (!this.host) return;
      const variant = this.selection();
      const quantity = Number(this.quantityInput.value);
      const validQuantity = Number.isInteger(quantity) && quantity >= 1 && quantity <= 999;
      this.host.dataset.shopifyVariant = variant ? String(variant.id) : '';
      this.host.dataset.shopifyCurrency = this.config.currency;
      this.form.elements.id.value = variant ? String(variant.id) : '';
      this.host.querySelector('[data-unit-price]').textContent = variant ? variant.formatted : '—';
      this.host.querySelector('[data-price]').textContent = variant && validQuantity ? this.format.format(variant.price * quantity / 100) : '—';
      let compare = this.host.querySelector('[data-market-compare]');
      if (!compare) {
        compare = document.createElement('s');
        compare.dataset.marketCompare = '';
        this.host.querySelector('[data-price]').after(compare);
      }
      compare.hidden = !variant || !validQuantity || !(variant.compareAt > variant.price);
      compare.textContent = compare.hidden ? '' : this.format.format(variant.compareAt * quantity / 100);
      const colour = this.host.querySelector('.nvp-colour input:checked')?.value;
      this.host.querySelectorAll('.nvp-unified-guide tbody tr').forEach(row => {
        const sized = this.config.variants.find(v => v.colour === colour && v.size === row.querySelector('th').textContent.trim());
        row.lastElementChild.textContent = sized ? sized.formatted : '—';
      });
      this.button.disabled = this.busy || !variant?.available || !validQuantity;
      this.button.textContent = this.busy ? this.config.labels.adding : variant?.available ? this.config.labels.add : this.config.labels.unavailable;
      this.host.querySelector('.nvp-buy-note').textContent = this.config.variants.length ? '' : this.config.labels.pending;
    }
    async add(event) {
      event.preventDefault();
      if (this.busy) return;
      const variant = this.selection();
      const quantity = Number(this.quantityInput.value);
      if (!variant?.available || !Number.isInteger(quantity) || quantity < 1 || quantity > 999) {
        this.refresh();
        return;
      }
      const error = this.host.querySelector('[data-commerce-error]');
      error.textContent = '';
      this.busy = true;
      this.form.setAttribute('aria-busy', 'true');
      this.refresh();
      try {
        const response = await fetch(this.config.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity }] })
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || this.config.labels.error);
        location.assign(this.config.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || this.config.labels.error;
      } finally {
        this.busy = false;
        this.form.removeAttribute('aria-busy');
        this.refresh();
      }
    }
  });
}
